import http from '@plugins/axios';
import { queryString } from '@utils/format';
/* eslint-disable no-empty-pattern */
export const state = {
  data: null,
  ajuan: null,
  date: null,
  aksesTimeTbs: false,
  wkt_online: null,
  isBlokir: false,
  menu: null,
  notifikasi: [],
  layanan: null,
};

export const mutations = {
  SET_DATA(state, newValue) {
    state.data = newValue ?? null;
  },
  SET_AJUAN(state, newValue) {
    state.ajuan = newValue ?? null;
  },
  SET_DATE(state, newValue) {
    state.date = newValue ?? null;
  },
  SET_AKSES_TIME_TBS(state, newValue) {
    state.aksesTimeTbs = newValue ?? false;
  },
  SET_WKT_ONLINE(state, newValue) {
    state.wkt_online = newValue;
  },
  SET_BLOKIR(state, newValue) {
    state.isBlokir = newValue;
  },
  SET_MENU(state, newValue) {
    state.menu = newValue;
  },
  SET_NOTIFIKASI(state, newValue) {
    state.notifikasi = newValue;
  },
  SET_LAYANAN(state, newValue) {
    state.layanan = newValue;
  },
};

export const actions = {
  async getPreferensi({ commit }, reset) {
    if (state.data && !reset) return Promise.resolve(state.data);
    const responses = await http.get('psp/gtk/preferensi', { params: {} });
    const serverTime = new Date(responses?.headers?.date ?? null);
    const timezone = 7;
    const today = new Date(
      serverTime.getUTCFullYear() +
        '/' +
        (serverTime.getUTCMonth() + 1) +
        '/' +
        serverTime.getUTCDate() +
        ' ' +
        serverTime.getUTCHours() +
        ':' +
        serverTime.getUTCMinutes()
    );
    const locaTime = new Date(today.getTime() + (Number(timezone) || 0) * 3600000);

    commit('SET_DATA', responses?.data?.data ?? null);
    commit('SET_MENU', responses?.data?.menu ?? null);
    commit('SET_NOTIFIKASI', responses?.data?.notifikasi ?? []);
    commit('SET_DATE', locaTime ?? null);
    return Promise.resolve(responses?.data ?? null);
  },

  async getAjuan({ commit }, payload) {
    const responses = await http.get(`psp/gtk/${payload.tipe === 'pa' ? 'pelatih-ahli' : 'peserta'}-ajuan`);

    commit('SET_AJUAN', responses?.data?.data?.ajuan ?? null);
    return Promise.resolve(responses?.data?.data?.ajuan ?? null);
  },

  daftarInfo({}, tipe) {
    return http
      .get(`psp/gtk/${tipe === 'pa' ? 'pelatih-ahli-pendaftaran' : 'peserta-pendaftaran'}`)
      .then(({ data }) => data);
  },

  checkUnsur({}, params) {
    return http.get(`psp/gtk/pelatih-ahli-pendaftaran/syarat?k_unsur_psp=${params}`).then(({ data }) => data);
  },

  daftar({}, payload) {
    return http.post(`psp/gtk/${payload.tipe === 'pa' ? 'pelatih-ahli' : 'peserta'}-pendaftaran/save`, payload.params);
  },

  daftaCadang({}, payload) {
    return http.post(
      `psp/gtk/${payload.tipe === 'pa' ? 'pelatih-ahli' : 'peserta'}-pendaftaran/save-cadangan`,
      payload.params
    );
  },

  cekSyarat({}, payload) {
    return http
      .get(`psp/gtk/${payload.tipe === 'pa' ? 'pelatih-ahli' : 'peserta'}-ajuan/syarat?${queryString(payload.params)}`)
      .then(({ data }) => data);
  },

  ajuan({}, payload) {
    return http.post(`psp/gtk/${payload.tipe === 'pa' ? 'pelatih-ahli' : 'peserta'}-ajuan/save`, payload.params);
  },

  setAksesTimeTbs({ commit }, value) {
    commit('SET_AKSES_TIME_TBS', value);
  },

  async getOnline({ commit }) {
    const resp = await http.get('/psp/gtk/preferensi/online').then(({ data }) => data);
    commit('SET_WKT_ONLINE', resp && resp.data && resp.data.time);
  },

  async getLayanan({ commit }) {
    const resp = await http.get('/psp/gtk/preferensi/layanans').then(({ data }) => data);
    commit('SET_LAYANAN', resp.data || {});

    return resp;
  },

  cekRekaman({}, payload) {
    return http.get(`/psp/gtk/preferensi/cek-rekaman?${queryString(payload)}`).then(({ data }) => data);
  },

  templatePakta({}) {
    const url = `psp/gtk/peserta-ajuan/template-pakta`;
    return Promise.resolve(url);
  },

  uploadPakta({}, { params }) {
    const url = `psp/gtk/peserta-ajuan/upload-pakta`;
    return http.post(url, params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  kirimPakta({}) {
    return http.post(`psp/gtk/peserta-ajuan/konfirmasi`).then(({ data }) => data);
  },

  daftarBatal({}) {
    return http.post(`psp/gtk/peserta-ajuan/batal`).then(({ data }) => data);
  },

  getDkp({}) {
    return http.get(`psp/gtk/dpp-profil`).then(({ data }) => data);
  },

  saveDkp({}, payload) {
    return http.post(`psp/gtk/dpp-profil/save`, payload);
  },

  setBlokir({ commit }, value) {
    commit('SET_BLOKIR', value);
  },
};
